import { defineComponent, computed } from '@vue/composition-api';
import __vue_component__ from '../SdsIcon/SdsIcon.vue.js';
import __vue_component__$1 from '../SdsButton/SdsButton.vue.js';
import { bannerVariantToButtonStyling } from './BannerVariantToButtonStyling.js';
import { BannerVariant } from './Banner.js';

var script = defineComponent({
    name: 'SdsBannerPromo',
    props: {
        banner: {
            type: Object,
            required: true,
        },
        imgPath: {
            type: String,
            required: false,
            default: '/static/img/promo-banners'
        },
        seoHref: {
            type: String,
            required: false,
            default: undefined,
        },
    },
    emits: ['click'],
    setup: function (props) {
        var showSvg = computed(function () {
            var variantsWithSvg = [
                BannerVariant.Primary,
                BannerVariant.PrimaryAlt,
                BannerVariant.SecondaryAlt2
            ];
            return variantsWithSvg.includes(props.banner.variant);
        });
        var svgFillColor = computed(function () {
            return props.banner.variant === BannerVariant.Primary
                ? 'var(--component-button-primary-bg)'
                : 'var(--component-button-primary-alt-bg)';
        });
        return {
            bannerVariantToButtonStyling: bannerVariantToButtonStyling,
            showSvg: showSvg,
            svgFillColor: svgFillColor,
            BannerVariant: BannerVariant,
        };
    },
    components: {
        SdsIcon: __vue_component__,
        SdsButton: __vue_component__$1,
    },
});

export default script;
